<div class="content-wrapper">
	<div class="content-body">

		<!-- content-header component -->
		<app-content-header [contentHeader]="contentHeader"></app-content-header>

		<div class="card">

			<!-- TABELA DE DADOS -->
			<section id="ngx-datatable-inline-editing">
				<!-- FUNCOES DA TABELA -->
				<div class="row">
					<div class="col-12">
						<button class="btn btn-primary float-right mr-1 mt-1"
							onclick="location.href='/grupo-permissao/cadastro'" rippleEffect>
							<i data-feather="plus" class="mr-0 mr-sm-1"></i><span
								class="d-none d-sm-inline-block">Adicionar</span>
						</button>
					</div>
				</div>
				<hr>

				<!-- FILTROS DA TABELA -->
				<div class="row">
					<div class="col-md-6 col-12">
						<div class="d-flex justify-content-between align-items-center m-1">
							<label class="d-flex align-items-center">Mostrar
								<select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
									<option value="10">10</option>
									<option value="25">25</option>
									<option value="50">50</option>
									<option value="100">100</option>
								</select>
							</label>
						</div>
					</div>
				</div>

				<!-- DATATABLE -->
				<ngx-datatable class="material core-bootstrap" [headerHeight]="40" [rowHeight]="58" [limit]="10"
					[columnMode]="ColumnMode.force" [footerHeight]="50" [headerHeight]="120" style="box-shadow: none"
					[limit]="basicSelectedOption" [rows]="rows" [scrollbarH]="true">

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false" name="Grupo" prop="grupo">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h6>Grupo</h6>
							<br>
							<input type="search" placeholder="Pesquisar Grupo" class="ml-25 form-control"
								(keyup)="grupoFilter($event)" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.grupo}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [width]="20" [sortable]="false">
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<div class="d-flex align-items-center">
								<div ngbDropdown container="body">
									<a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow"
										id="dropdownBrowserState" data-toggle="dropdown" aria-haspopup="true"
										aria-expanded="false">
										<i data-feather="more-vertical" class="text-primary cursor-pointer mr-50"></i>
									</a>
									<div ngbDropdownMenu class="dropdown-menu-right"
										aria-labelledby="dropdownBrowserState">
										<a href="/usuario/editar/{{row.id}}" ngbDropdownItem
											class="d-flex align-items-center"><i data-feather="file-text"
												class="mr-50"></i> Editar</a>
										<a (click)="msgConfirmacao(row.id)" ngbDropdownItem
											class="d-flex align-items-center"><i data-feather="trash-2"
												class="mr-50"></i> Excluir</a>
									</div>
								</div>
							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</section>

		</div>
	</div>
</div>